<template>
    <v-flex xs12>
      <v-card>
        <v-flex xs12 px-4 pt-4 v-if="err">
          <v-alert :value="true" type="error">{{err}}</v-alert>
        </v-flex>
        <v-card-title class="pb-3 px-2 layout row wrap">
          <v-btn class="primary my-0 mx-3" @click='$router.push({ name: "appResourceCreate" })'>{{ $lang.actions.createAppRes }}</v-btn>
          <v-checkbox
            color="primary"
            class="mx-1 mt-0"
            :label="$lang.labels.showActive"
            v-model="showActive"
            hide-details
          />
          <v-spacer />
          <v-autocomplete
            class="min-w max-w mx-3 pb-2"
            :label="$lang.actions.selectCompany"
            :items="mappedCompanies"
            :loading="companyLoading"
            v-model="selectedCompany"
            hide-details
          />
          <v-text-field
            v-if="show"
            class="min-w max-w mx-3 pb-2"
            v-model="search"
            append-icon="search"
            :label="$lang.labels.search"
            hide-details
          />
        </v-card-title>
        <v-data-table
          v-if="show"
          :headers="headers"
          :items="showActive ? activeAppResources : allAppResources"
          :search="search"
          :loading="loading"
          :rows-per-page-items="[50, 100, 250, 500, { text:'All' , value: -1 }]"
        >
          <v-progress-linear height="6" slot="progress" color="primary" indeterminate />
          <template slot="items" slot-scope="props">
            <td>{{ props.item.name }}</td>
            <td>{{ props.item.type }}</td>
            <td>{{ props.item.status }}</td>
            <td>{{ formatDate(props.item.createdOn) }}</td> 
            <td class="min-w-lg">
              <v-btn class="primary mx-0 elevation-1" @click="$router.push({ name: 'appResourceEdit', params: { id: props.item.id } })">{{$lang.actions.edit}}</v-btn>
              <v-btn class="primary elevation-1" @click="changeStatus(props.item)">{{props.item.status === 'active' ? $lang.actions.deactivate : $lang.actions.activate}}</v-btn>
            </td>
          </template>
          <v-alert slot="no-results" :value="true" color="warning" icon="warning">
            Your search for "{{ search }}" found no results.
          </v-alert>
        </v-data-table>
      </v-card>
    </v-flex>
</template>

<script>
  import {DateTime} from 'luxon';
import { company } from '../../assets/fetch_data';

  export default {
    data() {
      return {
        err: '',  
        search: '',
        show: false,
        loading: true,
        language: this.$cookie.get('lang') || 'en',
        companies: [],
        selectedCompany: '',
        companyLoading: true,
        headers: [
          { text: this.$lang.labels.name, value: 'name', align: 'left' },
          { text: this.$lang.labels.type, value: 'type', align: 'left' },
          { text: this.$lang.labels.status, value: 'status', align: 'left' },
          { text: this.$lang.labels.created, value: 'createdOn', align: 'left' },
          { text: this.$lang.labels.actions, value: 'actions', align: 'left', sortable: false },
        ],
        showActive: true,
        allAppResources: [],
      }
    },
    watch: {
      err(val) {
        if (val !== '') {
          setTimeout(() => { this.err = ''; }, 5000);
        }
      },
      selectedCompany(val) {
        this.fetchAppResourcesForCompany(val);
        this.$cookie.set('companyedit', val, { expires: '8h' });
      },
    },
    computed: {
      activeAppResources() {
        const appResources = this.allAppResources;
        const activeAppResources = [];
        for (let i=0; appResources.length > i; i++) {
          if (appResources[i].status === 'active') {
            activeAppResources.push(appResources[i]);
          }
        }
        return activeAppResources;
      },
      mappedCompanies() {
        return this.companies.map(company => ({
          text: `${company.name} (${company.companyStatus})`,
          value: company.id,
        }));
      },
    },
    methods: {
      formatDate(date) {
         return DateTime.fromISO(date).toFormat('yyyy-MM-dd HH:mm:ss');
      },
      init() {
        return new Promise((resolve) => {
            this.$http.get('company')
            .then((res) => {
              resolve()
              this.companyLoading = false;
              if (res.body.status === 'Success') {
                this.companies = res.body.companies;
                return;
              }
              this.err = res.body.statusText;
            }, (err) => {
              resolve()
              this.companyLoading = false;
              this.err = err.body.statusText || err.body.message;
            });
        });
      },
      changeStatus(appRes) {
        const action = appRes.status === 'active' ? 'deactivate' : 'activate';
        this.$http.post(`appresource/${action}/${appRes.id}`)
        .then((res) => {
          if (res.body.status === 'Success') {
            this.$set(appRes, 'status', action === 'activate' ? 'active' : 'inactive');
            return;
          }
          this.err = res.body.statusText;
        }, (err) => {
          this.err = err.body.statusText || err.body.message;
        });
      },
      fetchAppResourcesForCompany(id) {
        this.show = true;
        this.allAppResources = [];
        this.activeAppResource = [];
        this.$http.post('appresource/getall', { companyId: id })
        .then((res) => {
          this.loading = false;
          if (res.body.status === 'Success') {
            this.allAppResources = res.body.appResources;
            return;
          }
          if (this.allAppResources.length === 0) {
            this.loading = false;
          }
          this.err = res.body.statusText;
        }, (err) => {
          this.loading = false;
          this.err = err.body.statusText || err.body.message;
        });
      },
    },
    created() {
      this.init()
        .then(() => {
          const edit = this.$cookie.get('companyedit');
          if (edit) this.selectedCompany = edit;
        });
    },
  };
</script>


// WEBPACK FOOTER //
// AppResource.vue?68bbbd3e